// extracted by mini-css-extract-plugin
module.exports = {"title":"SliderContainer_title__7snOR","slider":"SliderContainer_slider__a7uOj","arrowBlock":"SliderContainer_arrowBlock__QVbck"};